module.exports = __webpack_public_path__ + "static/favicon-cd11000d88491eb3ba019716dc233a0b.ico";